export enum EventTemplateLayout {
  ONE_COLUMN = 'ONE_COLUMN',
  ONE_COLUMN_ELEGANT = 'ONE_COLUMN_ELEGANT',
  ONE_COLUMN_MODERN = 'ONE_COLUMN_MODERN',
  TWO_COLUMNS = 'TWO_COLUMNS',
}
